import { STARTER_TEMPLATES } from './schema';

const defaults = {
  outputType: 'html',
  starterTemplate: 'basic',
  template: STARTER_TEMPLATES.basic,
  primaryColor: '#2563eb',
  customCss: '',
  dateFormat: 'yyyy-MM-dd',
  currencyCode: 'USD',
};

export default defaults;
